import React from "react";
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import Helmet from "react-helmet";
import car from './../images/car.jpg';
import cal from './../images/cal.jpg';
import feedback from './../images/feedback.jpg';
import movie from './../images/movie.jpg';
import todo from './../images/todo.jpg';
import taco from './../images/taco.png';
import Carousel from 'nuka-carousel';


export default () => (
  <div className="c-content-box">
    <Helmet title="Let's play" />

    <HeadlineWithFocus>
      My Work
      {/* <span>What's that?</span> */}
    </HeadlineWithFocus>
    <br/>
    {/* <p>Coming soon...</p> */}
    <Carousel>
      <img src={taco} />
      <img src={car} />
      <img src={feedback} />
      <img src={movie} />
      <img src={cal} />
      <img src={todo} />
    </Carousel>
      <ol>
        <li>
          <a href="https://taco-fresh.herokuapp.com/">Taco Fresh</a>
        </li>
        <li>
          <a href="https://car-problems.herokuapp.com/#/home">Car probelms</a>
        </li>
        <li>
          <a href="https://feedback-form-01.herokuapp.com/">Feedback Form</a>
        </li>
        <li>
          <a href=" https://movie-list-01.herokuapp.com/">Movie List</a>
        </li>
        <li>
          <a href="https://simple-calculator-001.herokuapp.com/">Calculator server side</a>
        </li>
        <li>
          <a href="https://weekend-to-do-list-01.herokuapp.com/">To do list</a>
        </li>
      </ol>
    {/* <div id="carousel-example-2" class="carousel slide carousel-fade z-depth-1-half" data-ride="carousel">
  <ol class="carousel-indicators">
    <li data-target="#carousel-example-2" data-slide-to="0" class="active"></li>
    <li data-target="#carousel-example-2" data-slide-to="1"></li>
    <li data-target="#carousel-example-2" data-slide-to="2"></li>
  </ol>
  <div class="carousel-inner" role="listbox">
    <div class="carousel-item active">
      <div class="view">
        <img class="d-block w-100" src={car} alt="First slide" />
        <div class="mask rgba-black-light"></div>
      </div>
      <div class="carousel-caption">
        <h3 class="h3-responsive">This is the first title</h3>
        <p>First text</p>
      </div>
    </div>
    <div class="carousel-item">
      <div class="view">
        <img class="d-block w-100" src={feedback} alt="Second slide"/>
        <div class="mask rgba-black-light"></div>
      </div>
      <div class="carousel-caption">
        <h3 class="h3-responsive">Thir is the second title</h3>
        <p>Secondary text</p>
      </div>
    </div>
    <div class="carousel-item">
      <div class="view">
        <img class="d-block w-100" src={movie} alt="Third slide" />
        <div class="mask rgba-black-light"></div>
      </div>
      <div class="carousel-caption">
        <h3 class="h3-responsive">This is the third title</h3>
        <p>Third text</p>
      </div>
    </div>
  </div>
  <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
  </div> */}
    {/* <img 
      src={car} 
      alt="greglobinski.com"
    />
        <img 
      src={feedback} 
      alt="greglobinski.com"
    />
        <img 
      src={movie} 
      alt="greglobinski.com"
    />
        <img 
      src={movie} 
      alt="greglobinski.com"
    />
            <img 
      src={todo} 
      alt="greglobinski.com"
    /> */}
    {/* <p>
      I enjoy coding because I can see how little things make a big differences in coding. I first got into software engineering because of high school the first time I every did any time of coding.
      </p>
      <br/>
      <p>
      I have been on school with Prime Digital Academy for the past 4 months and I have learn the full stack development. It was hard to start from nothing and do a big jump of career change.
      </p>
      <br/>
      <p>
      One of my hobbies outside of work is cars. Just anything to do with them, like example racing, and talking about the new and old cars.
      </p> */}
      
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/projects.jsx